import STORES from './stores';
import { PRELOADER, PRELOADER_STYLES } from './preloader';

// eslint-disable-next-line import/prefer-default-export
export { STORES, PRELOADER, PRELOADER_STYLES };
